window.$ = window.jQuery = require('jquery');

import ChooseTeethsModal from './choose-teeths-modal';
import UploadcareMultiple from './upload-care-multiple';

/**
 * @class
 */
export default class NewOrder {
    /**
     * Initialize Header
     * @function
     */
    constructor(el) {
        this.el = el;
        if (!this.el.length) {
            return;
        }

        $('[data-choose-teeths]').each(function (index, value) {
            new ChooseTeethsModal($(value));
        });

        $('[data-multiple-uploadcare]').each(function (index, value) {
            new UploadcareMultiple($(value));
        });


        var $choose_teeth_modal = $('#choose-teeth-modal');
        var $teeth_map = $('.teeth-map');

        $teeth_map.find('.tooth-item').each(function () {
            $(this).on('click', () => {
                $(this).toggleClass('active');
                $teeth_map.find('[data-id=' + $(this).attr('id') + ']').prop('checked', function (i, val) {
                    let vl = !val;
                    $(this).attr('checked', vl);
                    return vl;
                });
            });
        });

        $teeth_map.find('.tooth-checkbox').change(function () {
            let $tooth_id = $('#' + $(this).attr('data-id'));
            if ($(this).prop('checked')) {
                $(this).attr('checked', true);
                $tooth_id.addClass('active');
            } else {
                $tooth_id.removeClass('active');
                $(this).attr('checked', false);
            }
        });

        $('.choose-teeth-btn').on('click', () => {
            let $dataInput = $('[data-choose-teeths="' + $teeth_map.attr('data-for-group') + '"]');
            let $dataForGroup = $dataInput.closest('label');
            let checkedTeeth = $teeth_map.find('.tooth-checkbox:checked');
            let checkedTeethHtml = '';
            checkedTeeth.each(function (value, index) {
                $(this).attr('name', $dataInput.attr('name') + '[tooth][' + $(this).val() + ']');
                checkedTeethHtml += $(this).closest('.teeth-label')[0].outerHTML;
            });
            $dataForGroup.find('.lbl-teeth').remove();
            $choose_teeth_modal.modal("hide");
            if (!checkedTeethHtml) {
                $dataInput.prop('checked', false);
                return;
            }
            $dataForGroup.append('<span class="lbl-txt lbl-teeth">&nbsp/&nbsp' + checkedTeethHtml + '</span>');
        });



        $('.choose-teeth-modal').find('.close').on('click', function () {
            let $dataInput = $('[data-choose-teeths="' + $teeth_map.attr('data-for-group') + '"]');
            let $dataForGroup = $dataInput.closest('label');
            $dataInput.prop('checked', false);
            $dataForGroup.find('.lbl-teeth').remove();

        });


        $('.choose-teeth-modal').on('click', function (event) {
            if (!$(event.target).closest('.modal-content').length) {
                let $dataInput = $('[data-choose-teeths="' + $teeth_map.attr('data-for-group') + '"]');
                let $dataForGroup = $dataInput.closest('label');
                $dataInput.prop('checked', false);
                $dataForGroup.find('.lbl-teeth').remove();
            }
        });
//        $choose_teeth_modal.on('hidden.bs.modal', function (e) {
//            alert(1);
//            let $dataInput = $('[data-choose-teeths="' + $teeth_map.attr('data-for-group') + '"]');
//            let $dataForGroup = $dataInput.closest('label');
//            let checkedTeeth = $teeth_map.find('.tooth-checkbox:checked');
//            let checkedTeethHtml = '';
//            checkedTeeth.each(function (value, index) {
//                $(this).attr('name', $dataInput.attr('name') + '[tooth][' + $(this).val() + ']');
//                checkedTeethHtml += $(this).closest('.teeth-label')[0].outerHTML;
//            });
//            $dataForGroup.find('.lbl-teeth').remove();
//            $choose_teeth_modal.modal("hide");
//            if (!checkedTeethHtml) {
//                $dataInput.prop('checked', false);
//                return;
//            }
//            $dataForGroup.append('<span class="lbl-txt lbl-teeth">&nbsp/&nbsp' + checkedTeethHtml + '</span>');
//        });



    }
}
